<template>
  <Modal
    ref="modal"
    title="Gedruckt optionen"
    class="modal-postcard-message-printed"
  >
    <template v-slot:content>
      <p id="_ModulePostcardMessageWrite">
        <FormInput type="textarea-embeded">
          <textarea
            v-model="validateMessage"
            :maxlength="maxLength"
            rows="10"
            required="true"
            placeholder="Grußkartentext hier eingeben…"
            class="form-input__control"
          ></textarea>
        </FormInput>
      </p>

      <MessageCharCounter
        :mode="2"
        :text="validateMessage"
      />
    </template>

    <template v-slot:footer>
      <Button
        @click="submit()"
        appearance="primary"
        :disabled="validateMessage.length < 1"
      >
        Auswahl bestätigen
      </Button>

      <Button
        @click="$refs.modal.close()"
        appearance="secondary"
      >
        Abbrechen
      </Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Composer/Modal';
import Button from '@/components/Common/Button';
import FormInput from '@/components/Common/FormInput';
import MessageCharCounter from '@/components/Composer/MessageCharCounter';

export default {
  name: 'ModalPostcardMessagePrinted',
  props: {
    selectionData: {
      type: Object
    }
  },
  data () {
    return {
      message: ''
    };
  },
  components: {
    Modal,
    Button,
    FormInput,
    MessageCharCounter
  },
  methods: {
    submit () {
      if (this.message.length > 1) {
        this.selectionData.mode = 2;

        this.selectionData.text = this.validateMessage;
      }

      this.$refs.modal.close({
        submit: true
      });
    }
  },
  computed: {
    maxLength: {
      get () {
        return 1200;
      }
    },
    validateMessage: {
      get () {
        return this.message;
      },
      set (value) {
        if (value.length > 1200) {
          value = value.substr(0, 1200);
        }

        this.message = value;
      }
    }
  },
  created () {
    this.message = this.selectionData.text;
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalPostcardMessagePrinted
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Printed message options
 * @since 2022-09-06
**/

$component: 'modal-postcard-message-printed';

.#{$component} {
  //…

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
